import {
    getPlaybook,
    getPlaybookForExport,
    listPlaybooks
} from './queries';
import {
    createPlaybook,
    deletePlaybook,
    importPlaybook,
    updatePlaybook,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreatePlaybook,
    DeletePlaybook,
    GetPlaybook,
    ListPlaybooks,
    GetPlaybookForExport,
    ImportPlaybook,
    Playbook,
    UpdatePlaybook
} from "../types.ts";
// FNP-917: Playbooks, Phases and Steps live in flexinet-workflows-api, NOT
// console-api. A bare generateClient() uses the DEFAULT Amplify endpoint
// (console-api), whose schema has zero Playbook/Phase/Step types — so every
// request failed schema validation IN THE BROWSER before reaching a server.
// Verified against the deployed dev console-api schema: 0 occurrences of
// "Playbook", "listPhases" and "listSteps"; "listAccounts" present.
//
// workflowsApiClient already existed, correctly configured per stage. This
// module simply was not using it.
import {workflowsApiClient} from "../../workflows-api-integration/client.ts";


const client = workflowsApiClient;

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListPlaybooks>>({
                                                                           query: listPlaybooks,
                                                                           variables: {
                                                                               filter: filter
                                                                           },
                                                                       });
    return response.data?.listPlaybooks.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPlaybook>>({
                                                                         query: getPlaybook,
                                                                         variables: {id: id},
                                                                     });
    return response.data?.getPlaybook;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePlaybook>>({
                                                                            query: createPlaybook,
                                                                            variables: {input: payload},
                                                                        });
    return response.data?.createPlaybook;
};

export const update = async (_id: string, record: Playbook) => {

    delete record.created;
    delete record.updated;
    delete record.createdByUsername

    const response = await client.graphql<GraphQLQuery<UpdatePlaybook>>({
                                                                            query: (updatePlaybook),
                                                                            variables: {input: record},
                                                                        });
    return response.data?.updatePlaybook;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePlaybook>>({
                                                                            query: (deletePlaybook),
                                                                            variables: {input: {id: id}},
                                                                        });
    return response.data?.deletePlaybook;
};

// FNP-1011: fetch the whole tree for export. Separate from `fetch` above,
// which stays flat — every other caller renders one record and should not pay
// for phases and steps it never displays.
export const fetchForExport = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPlaybookForExport>>({
                                                                                  query: getPlaybookForExport,
                                                                                  variables: {id: id},
                                                                              });
    return response.data?.getPlaybook;
};

// FNP-1011: recreate a playbook from an exported definition.
//
// ⚠️ The whole definition goes over as a JSON STRING, not a typed input. The
// point is to round-trip a FILE, and typing it in the schema would force the
// schema and the file format to evolve in lockstep — a file one version behind
// would fail with a GraphQL coercion error instead of the backend's readable
// "re-export from source" message.
export const importRecord = async (definition: string, name?: string) => {
    const input: {definition: string; name?: string} = {definition};
    if (name && name.trim() !== '') {
        input.name = name.trim();
    }

    const response = await client.graphql<GraphQLQuery<ImportPlaybook>>({
                                                                            query: (importPlaybook),
                                                                            variables: {input},
                                                                        });
    return response.data?.importPlaybook;
};
